import { Link } from "react-router-dom";
import { ShieldCheck, Award, Users, Building2 } from "lucide-react";

export default function About() {
    return (
        <div className="min-h-screen bg-navy-900">
            <section className="bg-navy-950 border-b border-white/5">
                <div className="max-w-7xl mx-auto px-6 lg:px-8 py-20">
                    <div className="label-overline mb-3">About Us</div>
                    <h1 className="font-heading text-4xl lg:text-6xl font-bold text-white max-w-4xl">Born in <span className="text-gold-500">Nagpur</span>, built for India.</h1>
                    <p className="text-white/70 mt-6 max-w-3xl text-lg leading-relaxed">
                        Global Property Mart is India's first ecosystem-style real-estate platform — combining listings, brokers, advocates, loans, and documentation in one trusted destination. Our mission: make every property transaction transparent, verified, and stress-free.
                    </p>
                </div>
            </section>

            <section className="max-w-7xl mx-auto px-6 lg:px-8 py-16 grid grid-cols-1 md:grid-cols-4 gap-6">
                {[
                    { icon: ShieldCheck, title: "Trust First", desc: "Every partner is RERA / Bar Council verified. Zero tolerance for fraud." },
                    { icon: Award, title: "Premium Service", desc: "Hand-picked advocates, brokers, and loan specialists with proven track records." },
                    { icon: Users, title: "Network Effects", desc: "1,200+ verified partners in 50+ cities. One referral, all services." },
                    { icon: Building2, title: "Made in India", desc: "Headquartered in Nagpur. Built for Indian property law and culture." },
                ].map((v) => {
                    const Icon = v.icon;
                    return (
                        <div key={v.title} className="rounded-2xl bg-navy-800 border border-white/5 p-6 hover:border-gold-500/40 hover-lift">
                            <Icon className="w-8 h-8 text-gold-500 mb-4" />
                            <h3 className="font-heading text-lg font-bold text-white mb-1">{v.title}</h3>
                            <p className="text-sm text-white/65">{v.desc}</p>
                        </div>
                    );
                })}
            </section>

            <section className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
                <div className="rounded-3xl glass p-12 text-center">
                    <h2 className="font-heading text-3xl lg:text-4xl font-bold text-white max-w-2xl mx-auto">Building the most trusted property service ecosystem in India.</h2>
                    <p className="text-white/65 mt-5 max-w-2xl mx-auto">Combining the best of MagicBricks, NoBroker, Urban Company, and Justdial — into one premium platform.</p>
                    <Link to="/contact" className="inline-block mt-8 px-6 py-3 rounded-md bg-gold-500 text-navy-900 font-semibold">Partner with us</Link>
                </div>
            </section>
        </div>
    );
}
